import { openDB } from 'idb';
export type EditingDraft = { key: string; fields: Record<string, string | boolean>; photo?: Blob | null; savedAt: string };
const database = () => openDB('compostdev_editing_drafts', 1, { upgrade(db) { db.createObjectStore('drafts', { keyPath: 'key' }); } });
export function editingDraftKey(scope: string | null, form: string, row: string): string | null {
  return scope && row ? `${scope}/${form}/${row}` : null;
}
export async function readEditingDraft(key: string | null): Promise<EditingDraft | null> {
  if (!key) return null;
  const db = await database();
  try { return await db.get('drafts', key) || null; } finally { db.close(); }
}
export async function writeEditingDraft(key: string, fields: EditingDraft['fields'], photo?: Blob | null) {
  const db = await database();
  try { await db.put('drafts', { key, fields, photo, savedAt: new Date().toISOString() }); } finally { db.close(); }
}
export async function discardEditingDraft(key: string | null) {
  if (!key) return;
  const db = await database();
  try { await db.delete('drafts', key); } finally { db.close(); }
}
export async function cacheOperatorRows(scope: string | null, rows: unknown[]) {
  if (!scope) return;
  const db = await database();
  try { await db.put('drafts', { key: `rows/${scope}`, rows, savedAt: Date.now() }); } finally { db.close(); }
}
export async function readOperatorRows(scope: string | null): Promise<unknown[]> {
  if (!scope) return [];
  const db = await database();
  try {
    const cache = await db.get('drafts', `rows/${scope}`);
    return cache && Date.now() - cache.savedAt < 86400000 ? cache.rows : [];
  } finally { db.close(); }
}
